import './QrCodeIcon.scss';

export { default } from './QrCodeIcon';
